import ListEquipmentPageMobile from "./ListEquipmentPageMobile";

export default ListEquipmentPageMobile;
